import React, { useEffect, useState, Fragment } from 'react';
import { Clock, ShieldCheck, X, ShoppingBag } from 'lucide-react';
import { useScrollProgress } from './hooks';
import { Button, scrollToCheckout } from './ui';
export const ProgressBar = () => {
  const progress = useScrollProgress();
  return <div className="fixed top-0 left-0 w-full h-1.5 z-50 bg-gray-200" data-id="element-24">
      <div className="h-full bg-herbal transition-all duration-150 ease-out" style={{
      width: `${progress * 100}%`
    }} data-id="element-25" />
    </div>;
};
export const UrgencyBar = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="fixed top-1.5 left-0 w-full z-40 overflow-hidden border-b border-gold/30" style={{
    background: 'linear-gradient(90deg, #0A2A2B 0%, #0F3D3E 30%, #165253 50%, #0F3D3E 70%, #0A2A2B 100%)',
    boxShadow: '0 4px 20px -5px rgba(15,61,62,0.6)'
  }} data-id="element-26">
      <div className="absolute inset-0 pointer-events-none opacity-40" style={{
      background: 'linear-gradient(90deg, transparent 0%, transparent 40%, rgba(201,168,76,0.15) 50%, transparent 60%, transparent 100%)',
      animation: 'shimmer 4s linear infinite'
    }} data-id="element-27"></div>

      <div className="relative max-w-[1200px] mx-auto py-2 px-4" data-id="element-28">
        <div className="flex items-center justify-center gap-3 sm:gap-4 text-xs sm:text-sm text-center flex-wrap" data-id="element-29">
          <div className="relative flex h-2.5 w-2.5 shrink-0" data-id="element-30">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-urgency opacity-75" data-id="element-31"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-urgency" data-id="element-32"></span>
          </div>

          <span className="text-white/95 font-medium" data-id="element-33">
            <span className="text-base sm:text-lg mr-1.5" aria-hidden data-id="element-34">
              ⚡
            </span>
            <span className="text-gold font-black tracking-wide" data-id="element-35">
              Oferta exclusiva
            </span>{' '}
            <span className="hidden sm:inline" data-id="element-36">— acceso completo por solo</span>
            <span className="bg-gold text-petroleum font-black px-2 py-0.5 rounded ml-1.5 sm:ml-2" data-id="element-37">
              $6,36 USD
            </span>
          </span>

          <div className="flex items-center gap-1.5 sm:gap-2 bg-black/30 backdrop-blur-sm border border-gold/40 px-2.5 py-1 rounded-lg" data-id="element-38">
            <span className="text-gold/80 text-[10px] font-bold tracking-widest hidden sm:inline" data-id="element-39">
              EXPIRA EN
            </span>
            <div className="flex items-center gap-1 font-heading font-bold text-white tabular-nums" data-id="element-40">
              <span className="bg-gold/20 px-1.5 py-0.5 rounded text-gold" data-id="element-41">
                {fmt(timeLeft.hours)}
              </span>
              <span className="text-gold/60 animate-pulse" data-id="element-42">:</span>
              <span className="bg-gold/20 px-1.5 py-0.5 rounded text-gold" data-id="element-43">
                {fmt(timeLeft.minutes)}
              </span>
              <span className="text-gold/60 animate-pulse" data-id="element-44">:</span>
              <span className="bg-gold/20 px-1.5 py-0.5 rounded text-gold" data-id="element-45">
                {fmt(timeLeft.seconds)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const progress = useScrollProgress();
  useEffect(() => {
    // Show after scrolling past hero (approx 15%) and hide near footer (approx 95%)
    if (progress > 0.15 && progress < 0.95) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [progress]);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 w-full z-40 bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-[0_-10px_30px_rgba(0,0,0,0.1)] p-4 transform transition-transform duration-500 animate-fade-in-up" data-id="element-46">
      <div className="max-w-[1200px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-47">
        <div className="hidden md:flex flex-col" data-id="element-48">
          <span className="font-heading font-bold text-petroleum text-lg" data-id="element-49">
            El Gran Manual Herbal
          </span>
          <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-50">
            <span className="line-through" data-id="element-51">$87 USD</span>
            <span className="font-bold text-herbal" data-id="element-52">Hoy: $6,36 USD</span>
          </div>
        </div>
        <Button size="md" className="w-full sm:w-auto shadow-glow-herbal" data-id="element-53">
          ✨ SÍ, QUIERO EL MANUAL COMPLETO
        </Button>
      </div>
    </div>;
};
export const ExitPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasTriggered, setHasTriggered] = useState(false);
  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0 && !hasTriggered) {
        setIsOpen(true);
        setHasTriggered(true);
      }
    };
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [hasTriggered]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-petroleum/80 backdrop-blur-sm" data-id="element-54">
      <div className="bg-cream rounded-3xl max-w-lg w-full p-8 relative shadow-2xl animate-fade-in-up" data-id="element-55">
        <button onClick={() => setIsOpen(false)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-56">
          <X size={24} data-id="element-57" />
        </button>

        <div className="text-center" data-id="element-58">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 text-urgency mb-4" data-id="element-59">
            <ShieldCheck size={32} data-id="element-60" />
          </div>
          <h3 className="font-heading text-3xl font-bold text-petroleum mb-2" data-id="element-61">
            ¡Espera! No te vayas con las manos vacías
          </h3>
          <p className="text-gray-600 mb-6" data-id="element-62">
            Estás a un paso de descubrir más de 970 remedios naturales. La
            oferta del{' '}
            <span className="font-bold text-urgency" data-id="element-63">93% de descuento</span>{' '}
            expira pronto.
          </p>

          <div className="bg-beige p-4 rounded-xl mb-6 border border-gold/30" data-id="element-64">
            <p className="font-bold text-petroleum mb-1" data-id="element-65">
              Llévate todo hoy por solo $6,36 USD
            </p>
            <p className="text-sm text-gray-600" data-id="element-66">+ 3 Bonos Exclusivos GRATIS</p>
          </div>

          <Button size="lg" className="w-full mb-3" onClick={e => {
          setIsOpen(false);
          scrollToCheckout(e);
        }} data-id="element-67">
            ✨ QUIERO APROVECHAR LA OFERTA
          </Button>

          <button onClick={() => setIsOpen(false)} className="text-sm text-gray-500 underline hover:text-gray-700" data-id="element-68">
            No gracias, prefiero seguir con mis molestias.
          </button>
        </div>
      </div>
    </div>;
};
const TOAST_DATA = [{
  name: 'Ana',
  city: 'Lima',
  photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=200&auto=format&fit=crop&crop=faces'
}, {
  name: 'Carmen',
  city: 'CDMX',
  photo: 'https://images.unsplash.com/photo-1581579438747-104c53e7ae4f?q=80&w=200&auto=format&fit=crop&crop=faces'
}, {
  name: 'María',
  city: 'Bogotá',
  photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop&crop=faces'
}, {
  name: 'Luciana',
  city: 'Medellín',
  photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=crop&crop=faces'
}, {
  name: 'Rosa',
  city: 'Santiago',
  photo: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=200&auto=format&fit=crop&crop=faces'
}, {
  name: 'Elena',
  city: 'Buenos Aires',
  photo: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?q=80&w=200&auto=format&fit=crop&crop=faces'
}, {
  name: 'Patricia',
  city: 'Madrid',
  photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=200&auto=format&fit=crop&crop=faces'
}];
const TIME_AGO_OPTIONS = ['hace 2 min', 'hace 4 min', 'hace 1 min', 'hace 5 min', 'justo ahora'];
export const PurchaseToasts = () => {
  const [toast, setToast] = useState<{
    name: string;
    city: string;
    photo: string;
    timeAgo: string;
  } | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showRandomToast = () => {
      const randomPerson = TOAST_DATA[Math.floor(Math.random() * TOAST_DATA.length)];
      const timeAgo = TIME_AGO_OPTIONS[Math.floor(Math.random() * TIME_AGO_OPTIONS.length)];
      setToast({
        ...randomPerson,
        timeAgo
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimer = setTimeout(showRandomToast, 4000);
    const interval = setInterval(showRandomToast, 14000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!toast) return null;
  return <div className={`fixed bottom-24 sm:bottom-6 left-4 z-50 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-10 opacity-0 scale-95 pointer-events-none'}`} data-id="element-69">
      <div className="relative" data-id="element-70">
        {/* Animated glow border */}
        <div className="absolute -inset-0.5 bg-gradient-to-r from-herbal via-gold to-herbal rounded-2xl blur-md opacity-70 animate-pulse-slow" data-id="element-71"></div>

        <div className="relative bg-white rounded-2xl border-2 border-herbal/40 p-3 pr-4 flex items-center gap-3 max-w-xs" style={{
        boxShadow: '0 15px 35px -8px rgba(39,174,96,0.35), 0 5px 12px -3px rgba(15,61,62,0.15)'
      }} data-id="element-72">
          {/* Photo with verified badge */}
          <div className="relative shrink-0" data-id="element-73">
            <div className="absolute -inset-0.5 bg-gradient-to-br from-herbal to-gold rounded-full" data-id="element-74"></div>
            <img src={toast.photo} alt={toast.name} className="relative w-12 h-12 rounded-full object-cover border-2 border-white" data-id="element-75" />
            <div className="absolute -bottom-1 -right-1 bg-herbal text-white rounded-full p-0.5 border-2 border-white" data-id="element-76">
              <ShoppingBag size={10} data-id="element-77" />
            </div>
          </div>

          <div className="flex-1 min-w-0" data-id="element-78">
            <p className="text-sm font-bold text-petroleum leading-tight truncate" data-id="element-79">
              {toast.name} de {toast.city}
            </p>
            <p className="text-xs text-gray-600 mt-0.5" data-id="element-80">
              acaba de adquirir el manual
            </p>
            <div className="flex items-center gap-1 mt-1 text-[10px] text-gray-400" data-id="element-81">
              <span className="relative flex h-1.5 w-1.5" data-id="element-82">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-herbal opacity-75" data-id="element-83"></span>
                <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-herbal" data-id="element-84"></span>
              </span>
              <span className="font-medium" data-id="element-85">{toast.timeAgo}</span>
              <span className="text-gold ml-auto font-bold" data-id="element-86">✓ Verificado</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export const CountdownTimer = ({
  variant = 'light'
}: {
  variant?: 'light' | 'dark';
}) => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  const blockClasses = variant === 'dark' ? 'bg-petroleum text-gold border-2 border-gold/40 shadow-glow-gold' : 'bg-white text-petroleum border-2 border-urgency/30 shadow-md';
  const labelClasses = variant === 'dark' ? 'text-gold/70' : 'text-urgency/70';
  return <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-87">
      {[{
      value: timeLeft.hours,
      label: 'HORAS'
    }, {
      value: timeLeft.minutes,
      label: 'MINUTOS'
    }, {
      value: timeLeft.seconds,
      label: 'SEGUNDOS'
    }].map((unit, i, arr) => <Fragment key={unit.label} data-id="element-88">
          <div className="flex flex-col items-center" data-id="element-89">
            <div className={`${blockClasses} font-heading font-bold text-3xl sm:text-5xl px-3 sm:px-5 py-2 sm:py-3 rounded-xl min-w-[3.5rem] sm:min-w-[5rem] text-center tabular-nums`} data-id="element-90">
              {format(unit.value)}
            </div>
            <span className={`text-[10px] sm:text-xs font-bold tracking-widest mt-2 ${labelClasses}`} data-id="element-91">
              {unit.label}
            </span>
          </div>
          {i < arr.length - 1 && <span className={`font-heading font-bold text-2xl sm:text-4xl ${variant === 'dark' ? 'text-gold' : 'text-urgency'} -mt-5 animate-pulse`} data-id="element-92">
              :
            </span>}
        </Fragment>)}
    </div>;
};